const PlanGetter = {
    plans: state => state.plans,
    subscribe: state => state.subscribe,
    userPlan: state => state.userPlan,
    planSummary: state => state.planSummary
};

export default PlanGetter;